import { render } from "./Contador.vue?vue&type=template&id=3943319e&scoped=true"
import script from "./Contador.vue?vue&type=script&lang=js"
export * from "./Contador.vue?vue&type=script&lang=js"

import "./Contador.vue?vue&type=style&index=0&id=3943319e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3943319e"]])

export default __exports__